import {Action, Module} from 'vuex-module-decorators';
import {SkillModel} from '@/models/skill.model';
import {SkillApi} from '@/api/skill.api';
import {take} from 'rxjs/operators';
import {EntityStateAdapter} from '@/store/base.store';

@Module
export class SkillStoreModule extends EntityStateAdapter<SkillModel> {

  @Action({commit: 'insertOne', rawError: true})
  addSkills(data: { contestant_id: number, skills: number[] }): void {
    // (new SkillApi())
    //     .add(data.contestant_id, data.skills)
    //     .pipe(take(1))
    //     .toPromise()
  }

  @Action({commit: 'insertMany', rawError: true})
  async requestAllSkills(): Promise<SkillModel[]> {
    if (!!this.entities && this.entities.length > 0) {
      return this.entities;
    }
    return await (new SkillApi())
      .all()
      .pipe(take(1))
      .toPromise()

  }


  get skills(): SkillModel[] {
    return this._entities;
  }

}
